let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dSNZF")).then(() => parcelRequire('6Y0wG'));